module.exports = __webpack_public_path__ + "media/corporate-image/tachikawalogo-white-723498b67e717692f0e7fa6cb49499c9.png";